import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { H2, Paragraph, Prose } from '@criteria-labs/react-typography';
import { ResponseList } from '../response-list';
import { Section } from '../section';
export function EndpointResponsesSection({ endpoint }) {
    const { responses = {} } = endpoint.operation;
    const responsesWithStatusCode = Object.entries(responses).filter(([statusCode, _]) => !statusCode.startsWith('x-'));
    return (_jsxs(Section, { children: [_jsx(Prose, { className: "max-w-none", children: _jsx(H2, { children: "Returns" }) }), responsesWithStatusCode.length === 0 && (_jsx(Prose, { className: "max-w-none", children: _jsx(Paragraph, { muted: true, children: "No return value." }) })), responsesWithStatusCode.length > 0 && (_jsx(ResponseList, { responses: Object.fromEntries(responsesWithStatusCode) }))] }));
}
